/**
 * This Component shows content after the permission modals without starting the camera.
 * @param props
 * @returns
 */
export const PostPermissionComponent = (props: any) => {
  return <>{props.children}</>;
};
